import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Scissors } from "@phosphor-icons/react";

export default function CutsPage() {
  const [cuts, setCuts] = useState([]);
  useEffect(() => {
    api.get("/cuts/recent", { params: { limit: 200 } }).then(({ data }) => setCuts(data));
  }, []);

  return (
    <div className="p-8 max-w-[1300px]">
      <header className="mb-8">
        <div className="text-xs font-mono tracking-[0.2em] uppercase text-slate-500 mb-2">History</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight text-slate-900">All Cuts</h1>
      </header>

      {cuts.length === 0 ? (
        <div className="border border-dashed border-slate-300 bg-white p-16 text-center">
          <Scissors size={32} className="mx-auto text-slate-300 mb-3" />
          <div className="text-sm text-slate-500">No cuts recorded yet.</div>
        </div>
      ) : (
        <div className="border border-slate-200 bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr className="text-left text-[10px] font-mono tracking-[0.2em] uppercase text-slate-500">
                <th className="px-4 py-3">When</th>
                <th className="px-4 py-3">Roll</th>
                <th className="px-4 py-3 text-right">Length</th>
                <th className="px-4 py-3">Customer</th>
                <th className="px-4 py-3">By</th>
                <th className="px-4 py-3">Notes</th>
              </tr>
            </thead>
            <tbody>
              {cuts.map((c) => (
                <tr key={c.id} className="border-b border-slate-100 last:border-0 hover:bg-slate-50">
                  <td className="px-4 py-3 font-mono text-xs">{new Date(c.cut_at).toLocaleString()}</td>
                  <td className="px-4 py-3 font-mono text-xs">
                    <Link to={`/rolls/${c.roll_id}`} className="text-blue-600 hover:underline">{c.roll_id.slice(0, 8)}…</Link>
                  </td>
                  <td className="px-4 py-3 font-mono text-right tabular-nums font-semibold">−{c.length_m.toFixed(2)}m</td>
                  <td className="px-4 py-3">{c.customer || "—"}</td>
                  <td className="px-4 py-3 text-slate-500 text-xs">{c.user_email}</td>
                  <td className="px-4 py-3 text-slate-600 max-w-xs truncate">{c.notes || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
